import React, { Component } from 'react';
import { Table } from 'antd';
import PropTypes from 'prop-types'
import './style.scss';
import { getTransactions } from './actions';
import moment from 'moment';
import {FaWpforms} from 'react-icons/fa'

class Transaction extends Component {
  static contextTypes = {formatMessage: PropTypes.any}

  constructor(props) {
    super(props)
    this.state = {
      spinner: true,
      transactions: [],
    }
  }

  async componentDidMount(){
    const transactions = await getTransactions();

    this.setState({
      transactions,
      spinner: false,
    })
  }
  

  render() {
    const {formatMessage} = this.context;
    const {spinner, transactions} = this.state;
    const columns = [
      {
        title: formatMessage('tbUserName'),
        dataIndex: 'user.username',
        key: 'username',
      }, {
        title: formatMessage('tbUserEmail'),
        dataIndex: 'user.email',
        key: 'email',
      },
      {
        title: formatMessage('tbAmount'),
        dataIndex: 'amount',
        key: 'amount',
        render: (text) => '$' + text + ' USD'
      },
      {
        title: formatMessage('tbMonths'),
        dataIndex: 'months',
        key: 'months',
      },
      {
        title: formatMessage('tbDiscount'),
        dataIndex: 'procent',
        key: 'procent',
        render: (text) => text + '%'
      },
      {
        title: formatMessage('tbDate'),
        dataIndex: 'created_at',
        key: 'created_at',
        render: (text) => moment.unix(text).format('LLL')
      },
      {
        title: formatMessage('tbId'),
        dataIndex: 'id',
        key: 'id',
        render: (text) => "#" + text
      },
      {
        title: formatMessage('tbTransactionId'),
        key: 'transaction_id',
        render: (text, item) => {
          const data = JSON.parse(item.data);
          if(data.transaction_id){
            return data.transaction_id;
          }
          const paypal = data.paypal || {};
          const id = paypal.purchase_units
          && paypal.purchase_units[0] 
          && paypal.purchase_units[0].payments 
          && paypal.purchase_units[0].payments.captures 
          && paypal.purchase_units[0].payments.captures[0] 
          && paypal.purchase_units[0].payments.captures[0].id ? paypal.purchase_units[0].payments.captures[0].id : '';
          return id;
        }
      },
      {
        title: formatMessage('tbUtlFile'),
        key: 'file_url',
        render: (value, item) => {
          
          return item.file_url ? <a target="_blank" href={item.file_url}><FaWpforms/></a> : '';
        }
      },
    ];

    return (
      <div className="AdminTransaction row">
        <div className="col-md-12">
          <Table loading={spinner} dataSource={transactions} columns={columns} bordered />
        </div>
      </div>
    );
  }
}

export default Transaction;



// WEBPACK FOOTER //
// ./yii2/frontend/frontend-assets/src/components/AdminPanel/Transactions/index.jsx